var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcLidOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7424 13.2025C22.5725 6.39897 28.6741 6.83018 31.0774 7.42039L33.3514 5.66837C34.0076 5.16275 34.9495 5.28484 35.4551 5.94107C35.9607 6.59731 35.8386 7.53917 35.1824 8.04479L4.68121 31.5456C4.02497 32.0512 3.0831 31.9291 2.57749 31.2729C2.07187 30.6167 2.19396 29.6748 2.85019 29.1692L3.09067 28.9839C3.33934 26.3503 4.91231 20.0059 13.7424 13.2025ZM29.1759 23.7715L32.6062 21.048C36.0634 25.4025 37.0078 29.326 35.8073 33.8287C39.2931 29.6311 41.532 23.8953 37.5402 17.1307L40.8765 14.4818L30.0597 12.855L29.1759 23.7715ZM3.99986 35H39.9999L37.9999 42H3.99986V35Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcLidOpen);
export default __webpack_public_path__ + "static/media/mc_lid_open.78c7c036834095f58c6815088118140e.svg";
export { ForwardRef as ReactComponent };